import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import BookCover from "@/components/landing/BookCover";

const EASE = [0.16, 1, 0.3, 1];

const PACKS = [  {
    id: "memorisation",
    cover: "mem",
    title: "Guide de mémorisation",
    sub: "En 6 mois",
    steps: ["Planification structurée", "Techniques éprouvées", "Suivi de progression", "Motivation spirituelle"],
    price: "29,99 €",
    cta: "Commencer",
    bundle: false,
  },
  {
    id: "revision",
    cover: "rev",
    title: "Guide de révision",
    sub: "En 30 jours",
    steps: ["Planning jour par jour", "Techniques de révision", "Suivi de progression", "Conseils pratiques"],
    price: "24,99 €",
    cta: "Réviser",
    bundle: false,
  },
  {
    id: "pack-complet",
    cover: null,
    title: "Pack Gold",
    sub: "Mémorisation + révision",
    steps: ["Les 2 guides réunis", "Un parcours de bout en bout", "Accès à vie", "9,99 € d'économie"],
    oldPrice: "54,98 €",
    price: "44,99 €",
    cta: "Tout obtenir",
    bundle: true,
  },
];

export default function Packs() {
  return (
    <section className="packs" id="packs" data-testid="packs-section">
      <div className="container">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
        >
          <div className="eyebrow">Les guides</div>
          <h2>Choisis ton point de départ</h2>
          <p>Chaque guide te donne un planning, une méthode et un suivi — à toi de choisir par où commencer.</p>
        </motion.div>

        <div className="pack-grid">
          {PACKS.map((p, i) => (
            <motion.div
              key={p.id}
              className={`pack-card ${p.bundle ? "bundle" : ""}`}
              initial={{ opacity: 0, y: 70 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-90px" }}
              transition={{ duration: 1, delay: i * 0.12, ease: EASE }}
              whileHover={{ y: -8 }}
              data-testid={`pack-card-${p.id}`}
            >
              {p.cover && (
                <div className="pack-cover-clip">
                  <BookCover variant={p.cover} mini />
                </div>
              )}
              <h3>{p.title}</h3>
              <div className="sub">{p.sub}</div>
              <ul className="steps">
                {p.steps.map((s, j) => (
                  <li key={j}>
                    <span className="step-num">{j + 1}</span>
                    {s}
                  </li>
                ))}
              </ul>
              {p.oldPrice && <div className="old-price">{p.oldPrice}</div>}
              <div className="price" data-testid={`pack-price-${p.id}`}>{p.price}</div>
              <Link
                to={`/commander?produit=${p.id}`}
                className={`btn ${p.bundle ? "btn-light" : ""}`}
                data-testid={`buy-${p.id}-btn`}
              >
                {p.cta}
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
